const STORAGE_PREFIX = 'mundpay_fees_selected_methods_';

export function loadFeesSelectedMethods(feeType: string): string[] | null {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${feeType}`);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;

    return parsed.filter((value): value is string => typeof value === 'string');
  } catch {
    return null;
  }
}

export function saveFeesSelectedMethods(feeType: string, methods: string[]): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${feeType}`, JSON.stringify(methods));
  } catch {
    // private mode / quota
  }
}

export function defaultFeesSelectedMethods(available: string[]): string[] {
  if (available.includes('credit_card')) {
    return ['credit_card'];
  }

  return available[0] ? [available[0]] : [];
}

export function resolveFeesSelectedMethods(
  feeType: string,
  available: string[],
): string[] {
  const stored = loadFeesSelectedMethods(feeType);
  const valid = stored?.filter((id) => available.includes(id)) ?? [];

  if (valid.length > 0) {
    return valid;
  }

  return defaultFeesSelectedMethods(available);
}
